class GoogleAnalytics {
  constructor($rootScope, $window, $location) {
    "ngInject";

    const track = () => {
      $window.ga.push(["_trackPageview", $location.path()]);
    };
    $rootScope.$on("$routeChangeSuccess", track);
  }
}

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./src/services/googleAnalytics/googleAnalytics.service.js